import React, {
    Fragment,
    useState,
    useRef,
    useEffect
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';


import HeaderUno
    from '../Metodos/Compartidos/HeaderUno';

import HeaderDos
    from '../Metodos/Compartidos/HeaderDos';

import useConfigAuth
    from '../../Hooks/useConfigAuth';

import SelectorUbicacion
    from '../Metodos/Compartidos/Ubicacion/SelectorUbicacion';

import LogoDocumentos
    from './LogoDocumentos';


import {
    nivelEstudiosData,
    tipoProfesionalData,
    ocupacionProfesionalData,
    generoData
} from '../../Hooks/dropdowns';


import {
    CuerpoCompleto
} from '../Css/StyledHeader';


import {
    PaginaPerfil,
    EncabezadoPagina,
    TituloPagina,
    DescripcionPagina,

    MensajeEstado,

    GridTarjetas,

    Tarjeta,
    TarjetaAncha,

    CabeceraTarjeta,
    BloqueTituloTarjeta,
    TituloTarjeta,
    SubtituloTarjeta,

    BotonEditarTarjeta,
    IconoBoton,

    DatosGrid,
    DatoBloque,
    EtiquetaDato,
    ValorDato,

    PanelEdicion,

    GridCampos,
    Campo,
    LabelCampo,
    InputCampo,

    TextoAyuda,
    TextoError,

    BloqueUbicacion,
    AvisoLegacy,

    FilaAcciones,

    BotonPrimario,
    BotonSecundario,
    BotonPeligro,

    SeguridadAcciones,
    BotonSeguridad,

    ListaConsultorios,
    TarjetaConsultorio,
    CabeceraConsultorio,
    NombreConsultorio,
    BadgeDefault,
    DatosConsultorio,
    AccionesConsultorio,

    EstadoVacio,

    FilaCheckbox,
    Checkbox
} from '../Css/StyledAdministrarPerfil';


import {
    almacenarNombreApellidoAction,
    almacenarEmailAction,
    almacenarRestoAction,
    almacenarContraseniaAction
} from '../../actions/almacenarPerfilActions';

import {
    estadoLoadingInitialAction
} from '../../actions/resetStoreActions';


import {
    setearAlerta,
    ocultarAlertaAction
} from '../../actions/alertaActions';


import {
    solicitoPerfilProfesionalAction,
    solicitoTokenPerfilProfesionalAction
} from '../../actions/cargarPerfilActions';


import {
    cargarConsultoriosProfesionalAction,
    crearConsultorioProfesionalAction,
    editarConsultorioProfesionalAction,
    borrarConsultorioProfesionalAction
} from '../../actions/consultoriosPerfilActions';


/*
========================================
FECHA PARA INPUT
========================================
*/

const formatearFechaParaInput = (
    fecha
) => {

    if (!fecha) {
        return '';
    }


    const fechaString =
        String(
            fecha
        ).trim();


    /*
    DD/MM/AAAA
    */

    if (
        /^\d{2}\/\d{2}\/\d{4}$/
            .test(
                fechaString
            )
    ) {

        const [
            dia,
            mes,
            anio
        ] =
            fechaString.split('/');


        return `${anio}-${mes}-${dia}`;

    }


    /*
    AAAA-MM-DD / ISO
    */

    if (
        /^\d{4}-\d{2}-\d{2}/
            .test(
                fechaString
            )
    ) {

        return fechaString.substring(
            0,
            10
        );

    }


    return '';

};


/*
========================================
FECHA PARA MOSTRAR
========================================
*/

const formatearFechaParaMostrar = (
    fecha
) => {

    if (!fecha) {
        return 'Sin especificar';
    }


    const fechaString =
        String(
            fecha
        ).trim();


    if (
        /^\d{2}\/\d{2}\/\d{4}$/
            .test(
                fechaString
            )
    ) {

        return fechaString;

    }


    if (
        /^\d{4}-\d{2}-\d{2}/
            .test(
                fechaString
            )
    ) {

        const fechaCorta =
            fechaString.substring(
                0,
                10
            );


        const [
            anio,
            mes,
            dia
        ] =
            fechaCorta.split('-');


        return `${dia}/${mes}/${anio}`;

    }


    return fechaString;

};


/*
========================================
OBTENER ETIQUETA DE OPCIÓN
========================================
*/

const obtenerEtiquetaOpcion = (
    opciones,
    valor
) => {

    if (
        valor === undefined ||
        valor === null ||
        valor === ''
    ) {

        return 'Sin especificar';

    }


    const encontrado =
        opciones.find(
            opcion =>

                String(
                    opcion.id
                ) ===
                String(
                    valor
                ) ||

                String(
                    opcion.parametro
                ) ===
                String(
                    valor
                )
        );


    return (
        encontrado?.parametro ||
        String(valor)
    );

};


/*
========================================
NORMALIZAR VALOR PARA SELECT
========================================

Algunos usuarios viejos tienen IDs.

Algunos registros nuevos pueden tener
temporalmente el texto.

Si encontramos el texto en el catálogo,
lo convertimos al ID.
========================================
*/

const normalizarValorSelect = (
    opciones,
    valor
) => {

    if (
        valor === undefined ||
        valor === null ||
        valor === ''
    ) {

        return '';

    }


    const encontrado =
        opciones.find(
            opcion =>

                String(
                    opcion.id
                ) ===
                String(
                    valor
                ) ||

                String(
                    opcion.parametro
                ) ===
                String(
                    valor
                )
        );


    if (
        encontrado
    ) {

        return String(
            encontrado.id
        );

    }


    /*
    Si todavía existe un valor legacy
    que no forma parte del catálogo,
    lo preservamos.
    */

    return String(
        valor
    );

};


/*
========================================
AGREGAR OPCIÓN LEGACY SI HACE FALTA
========================================
*/

const obtenerOpcionesSelect = (
    opciones,
    valorActual
) => {

    if (
        !valorActual
    ) {

        return opciones;

    }


    const existe =
        opciones.some(
            opcion =>
                String(
                    opcion.id
                ) ===
                String(
                    valorActual
                )
        );


    if (
        existe
    ) {

        return opciones;

    }


    return [

        {
            id:
                valorActual,

            parametro:
                valorActual
        },

        ...opciones

    ];

};


/*
========================================
UBICACIÓN PARA MOSTRAR
========================================
*/

const formatearUbicacionParaMostrar = ({
    ubicacion,
    pais,
    provincia,
    departamento,
    localidad
}) => {

    let partes =
        [];


    /*
    ====================================
    UBICACIÓN NUEVA
    ====================================
    */

    if (
        ubicacion &&
        typeof ubicacion ===
        'object' &&
        ubicacion.pais_codigo
    ) {

        if (
            ubicacion.pais_codigo ===
            'OTRO'
        ) {

            partes = [

                ubicacion.pais,

                ubicacion.provincia,

                ubicacion.localidad

            ];

        } else {

            const niveles =
                Object
                    .values(
                        ubicacion.niveles ||
                        {}
                    )
                    .filter(Boolean)
                    .sort(
                        (a, b) =>
                            Number(
                                a?.nivel ||
                                0
                            ) -
                            Number(
                                b?.nivel ||
                                0
                            )
                    );


            partes = [

                ubicacion.pais,

                ...niveles.map(
                    nivel =>
                        nivel?.nombre
                ),

                ubicacion.localidad_manual

            ];

        }

    } else {

        /*
        ====================================
        LEGACY
        ====================================
        */

        partes = [

            pais,
            provincia,
            departamento,
            localidad

        ];

    }


    const partesLimpias =
        partes
            .filter(Boolean)
            .map(
                parte =>
                    String(
                        parte
                    ).trim()
            )
            .filter(Boolean);


    /*
    Evita repeticiones visuales.

    El JSON no se modifica.
    */

    const partesSinDuplicados =
        partesLimpias.filter(
            (
                parte,
                indice
            ) =>

                partesLimpias.findIndex(
                    item =>
                        item ===
                        parte
                ) ===
                indice
        );


    return partesSinDuplicados.join(
        ', '
    );

};


/*
========================================
VALIDAR UBICACIÓN
========================================
*/

const validarUbicacion = (
    ubicacion
) => {

    if (
        !ubicacion ||
        typeof ubicacion !==
        'object' ||
        !ubicacion.pais_codigo
    ) {

        return false;

    }


    /*
    ====================================
    OTRO PAÍS
    ====================================
    */

    if (
        ubicacion.pais_codigo ===
        'OTRO'
    ) {

        return Boolean(

            String(
                ubicacion.pais ||
                ''
            ).trim() &&

            String(
                ubicacion.provincia ||
                ''
            ).trim() &&

            String(
                ubicacion.localidad ||
                ''
            ).trim()

        );

    }


    /*
    ====================================
    PAÍS CON CATÁLOGO
    ====================================
    */

    const niveles =
        Object
            .values(
                ubicacion.niveles ||
                {}
            )
            .filter(Boolean);


    if (
        niveles.length ===
        0
    ) {

        return false;

    }


    const tieneLocalidad =
        niveles.some(
            nivel =>
                nivel?.es_localidad ===
                true
        );


    if (
        tieneLocalidad
    ) {

        return true;

    }


    /*
    No encuentro mi localidad.
    */

    return Boolean(

        String(
            ubicacion.localidad_manual ||
            ''
        ).trim()

    );

};


/*
========================================
COMPONENTE
========================================
*/

const AdministrarPerfil = () => {

    const dispatch =
        useDispatch();


    const [
        config
    ] =
        useConfigAuth();

    /*
    ========================================
    REINICIAR LOADING AL ENTRAR AL PERFIL
    ========================================
    */

    useEffect(() => {

        dispatch(
            estadoLoadingInitialAction()
        );

    }, [dispatch]);


    /*
    ====================================
    REDUX
    ====================================
    */

    const cargando =
        useSelector(
            state =>
                state.estado.loading
        );


    const error =
        useSelector(
            state =>
                state.estado.error
        );


    const alerta =
        useSelector(
            state =>
                state.alertas.alerta
        );


    const estado =
        useSelector(
            state =>
                state.estado.correcto
        );


    const perfil =
        useSelector(
            state =>
                state.usuario.perfil ||
                {}
        );

    /*
    ========================================
    CARGAR PERFIL SI TODAVÍA NO ESTÁ EN REDUX
    ========================================

    Esto permite entrar al perfil desde:

    - Navbar
    - Sidebar
    - URL directa
    - Refresh del navegador

    sin depender de que otro componente
    haya cargado previamente los datos.
    ========================================
    */

    const perfilSolicitadoRef =
        useRef(false);


    useEffect(() => {

        if (
            !config ||
            perfilSolicitadoRef.current
        ) {

            return;

        }


        if (
            Object.keys(
                perfil
            ).length >
            0
        ) {

            return;

        }


        perfilSolicitadoRef.current =
            true;


        dispatch(
            solicitoPerfilProfesionalAction({
                config
            })
        );

    }, [
        config,
        dispatch,
        perfil
    ]);

    const {

        nombre,
        apellido,
        email,

        genero,
        fecha_nacimiento,

        nivel_estudios,
        ocupacion,
        matricula,

        profesion,
        otroProfesion,

        /*
        Legacy ubicación
        */

        pais,
        provincia,
        departamento,
        localidad,

        /*
        Nueva ubicación
        */

        ubicacion

    } =
        perfil;


    const consultoriosProfesional =
        useSelector(
            state =>
                state.usuario
                    .consultorios_profesional ||
                []
        );


    const consultoriosCargando =
        useSelector(
            state =>
                state.usuario
                    .consultorios_profesional_cargando
        );


    /*
    ====================================
    EDICIÓN - IDENTIDAD
    ====================================
    */

    const [
        editarIdentidad,
        setEditarIdentidad
    ] =
        useState(false);


    const [
        nombreEditar,
        setNombreEditar
    ] =
        useState('');


    const [
        apellidoEditar,
        setApellidoEditar
    ] =
        useState('');


    const [
        errorIdentidad,
        setErrorIdentidad
    ] =
        useState('');


    /*
    ====================================
    EDICIÓN - DATOS PERSONALES
    ====================================
    */

    const [
        editarPersonales,
        setEditarPersonales
    ] =
        useState(false);


    const [
        generoEditar,
        setGeneroEditar
    ] =
        useState('');


    const [
        fechaNacimientoEditar,
        setFechaNacimientoEditar
    ] =
        useState('');


    const [
        errorPersonales,
        setErrorPersonales
    ] =
        useState('');


    /*
    ====================================
    EDICIÓN - DATOS PROFESIONALES
    ====================================
    */

    const [
        editarProfesionales,
        setEditarProfesionales
    ] =
        useState(false);


    const [
        profesionEditar,
        setProfesionEditar
    ] =
        useState('');


    const [
        otroProfesionEditar,
        setOtroProfesionEditar
    ] =
        useState('');


    const [
        nivelEstudiosEditar,
        setNivelEstudiosEditar
    ] =
        useState('');


    const [
        ocupacionEditar,
        setOcupacionEditar
    ] =
        useState('');


    const [
        matriculaEditar,
        setMatriculaEditar
    ] =
        useState('');


    const [
        errorProfesionales,
        setErrorProfesionales
    ] =
        useState('');


    /*
    ====================================
    EDICIÓN - UBICACIÓN
    ====================================
    */

    const [
        editarUbicacion,
        setEditarUbicacion
    ] =
        useState(false);


    const [
        ubicacionEditar,
        setUbicacionEditar
    ] =
        useState({});


    const [
        errorUbicacion,
        setErrorUbicacion
    ] =
        useState('');


    /*
    ====================================
    SEGURIDAD
    ====================================
    */

    const [
        openEmail,
        setOpenEmail
    ] =
        useState(false);


    const [
        cambiarEmail,
        setCambiarEmail
    ] =
        useState(false);


    const [
        openContrasenia,
        setOpenContrasenia
    ] =
        useState(false);


    const [
        incompletoEmailProfesional,
        setIncompletoEmailProfesional
    ] =
        useState(false);


    const [
        incompletoPassword,
        setIncompletoPassword
    ] =
        useState(false);


    /*
    ====================================
    CONSULTORIOS
    ====================================
    */

    const consultoriosSolicitadosRef =
        useRef(false);


    const [
        openConsultorios,
        setOpenConsultorios
    ] =
        useState(false);


    const [
        consultorioEditandoId,
        setConsultorioEditandoId
    ] =
        useState(null);


    const [
        consultorioNombre,
        setConsultorioNombre
    ] =
        useState('');


    const [
        consultorioDireccion,
        setConsultorioDireccion
    ] =
        useState('');


    const [
        consultorioTelefono,
        setConsultorioTelefono
    ] =
        useState('');


    const [
        consultorioDefault,
        setConsultorioDefault
    ] =
        useState(false);


    /*
    ====================================
    REFS SEGURIDAD
    ====================================
    */

    const emailProfesional =
        useRef();


    const tokenRecupero =
        useRef();


    const password =
        useRef();


    const passwordNueva =
        useRef();


    const verificarPasswordNueva =
        useRef();


    /*
    ====================================
    UBICACIÓN PARA MOSTRAR
    ====================================
    */

    const ubicacionMostrada =
        formatearUbicacionParaMostrar({

            ubicacion,
            pais,
            provincia,
            departamento,
            localidad

        });


    /*
    ====================================
    TEXTOS PARA MOSTRAR
    ====================================
    */

    const generoMostrar =
        obtenerEtiquetaOpcion(
            generoData,
            genero
        );


    const estudiosMostrar =
        obtenerEtiquetaOpcion(
            nivelEstudiosData,
            nivel_estudios
        );


    const profesionMostrar =
        obtenerEtiquetaOpcion(
            tipoProfesionalData,
            profesion
        );


    const ocupacionMostrar =
        obtenerEtiquetaOpcion(
            ocupacionProfesionalData,
            ocupacion
        );


    /*
    ========================================
    CONSTRUIR PAYLOAD DE RESTO
    ========================================

    ModificoRestoPerfilProfesional todavía
    guarda estos datos juntos.

    Por eso cada tarjeta manda los valores
    actuales de las otras tarjetas.

    PERO:

    nombre/apellido NO están acá.

    La restricción de los 90 días queda
    completamente aislada.
    ========================================
    */

    const construirPayloadResto = (
        cambios = {}
    ) => {

        const profesionFinal =
            cambios.profesion !==
            undefined
                ?
                cambios.profesion
                :
                profesion;


        const payload = {

            profesion:
                profesionFinal ||
                '',

            otroProfesion:
                String(
                    profesionFinal
                ) ===
                '99'
                    ?
                    (
                        cambios.otroProfesion !==
                        undefined
                            ?
                            cambios.otroProfesion
                            :
                            otroProfesion
                    ) ||
                    ''
                    :
                    '',

            ocupacion:
                cambios.ocupacion !==
                undefined
                    ?
                    cambios.ocupacion
                    :
                    ocupacion ||
                    '',

            genero:
                cambios.genero !==
                undefined
                    ?
                    cambios.genero
                    :
                    genero ||
                    '',

            fecha_nacimiento:
                cambios.fecha_nacimiento !==
                undefined
                    ?
                    cambios.fecha_nacimiento
                    :
                    formatearFechaParaInput(
                        fecha_nacimiento
                    ),

            nivel_estudios:
                cambios.nivel_estudios !==
                undefined
                    ?
                    cambios.nivel_estudios
                    :
                    nivel_estudios ||
                    '',

            matricula:
                cambios.matricula !==
                undefined
                    ?
                    cambios.matricula
                    :
                    matricula ||
                    ''

        };


        /*
        Solamente se manda ubicación
        cuando la tarjeta Ubicación
        la está guardando explícitamente.
        */

        if (
            cambios.ubicacion !==
            undefined
        ) {

            payload.ubicacion =
                cambios.ubicacion;

        }


        return payload;

    };


    /*
    ========================================
    IDENTIDAD
    ========================================

    Esta tarjeta llama exclusivamente al
    endpoint de nombre/apellido.

    La restricción de 90 días NO afecta
    ninguna otra tarjeta.
    ========================================
    */

    const abrirEditarIdentidad = () => {

        setNombreEditar(
            nombre ||
            ''
        );


        setApellidoEditar(
            apellido ||
            ''
        );


        setErrorIdentidad(
            ''
        );


        setEditarIdentidad(
            true
        );

    };


    const cancelarEditarIdentidad = () => {

        setErrorIdentidad(
            ''
        );


        setEditarIdentidad(
            false
        );

    };


    const guardarIdentidad = (
        e
    ) => {

        e.preventDefault();


        const nombreLimpio =
            nombreEditar.trim();


        const apellidoLimpio =
            apellidoEditar.trim();


        if (
            !nombreLimpio ||
            !apellidoLimpio
        ) {

            setErrorIdentidad(
                'Nombre y apellido son obligatorios.'
            );


            return;

        }


        dispatch(
            ocultarAlertaAction()
        );


        dispatch(
            almacenarNombreApellidoAction({

                payload: {

                    nombre:
                        nombreLimpio,

                    apellido:
                        apellidoLimpio

                },

                config

            })
        );


        setEditarIdentidad(
            false
        );

    };


    /*
    ========================================
    DATOS PERSONALES
    ========================================

    Género y fecha de nacimiento tienen
    su propio guardado.

    Nunca intentan modificar nombre o
    apellido.
    ========================================
    */

    const abrirEditarPersonales = () => {

        setGeneroEditar(
            normalizarValorSelect(
                generoData,
                genero
            )
        );


        setFechaNacimientoEditar(
            formatearFechaParaInput(
                fecha_nacimiento
            )
        );


        setErrorPersonales(
            ''
        );


        setEditarPersonales(
            true
        );

    };


    const cancelarEditarPersonales = () => {

        setErrorPersonales(
            ''
        );


        setEditarPersonales(
            false
        );

    };


    const guardarDatosPersonales = (
        e
    ) => {

        e.preventDefault();


        if (
            !generoEditar ||
            !fechaNacimientoEditar
        ) {

            setErrorPersonales(
                'Completá género y fecha de nacimiento.'
            );


            return;

        }


        const payload =
            construirPayloadResto({

                genero:
                    generoEditar,

                fecha_nacimiento:
                    fechaNacimientoEditar

            });


        dispatch(
            ocultarAlertaAction()
        );


        dispatch(
            almacenarRestoAction({

                payload,

                config

            })
        );


        setEditarPersonales(
            false
        );

    };


    /*
    ========================================
    DATOS PROFESIONALES
    ========================================
    */

    const abrirEditarProfesionales = () => {

        setProfesionEditar(
            normalizarValorSelect(
                tipoProfesionalData,
                profesion
            )
        );


        setOtroProfesionEditar(
            otroProfesion ||
            ''
        );


        setNivelEstudiosEditar(
            normalizarValorSelect(
                nivelEstudiosData,
                nivel_estudios
            )
        );


        setOcupacionEditar(
            normalizarValorSelect(
                ocupacionProfesionalData,
                ocupacion
            )
        );


        setMatriculaEditar(
            matricula ||
            ''
        );


        setErrorProfesionales(
            ''
        );


        setEditarProfesionales(
            true
        );

    };


    const cancelarEditarProfesionales = () => {

        setErrorProfesionales(
            ''
        );


        setEditarProfesionales(
            false
        );

    };


    const guardarDatosProfesionales = (
        e
    ) => {

        e.preventDefault();


        if (
            !profesionEditar
        ) {

            setErrorProfesionales(
                'Seleccioná una profesión.'
            );


            return;

        }


        if (
            String(
                profesionEditar
            ) ===
            '99' &&

            !otroProfesionEditar
                .trim()
        ) {

            setErrorProfesionales(
                'Completá cuál es tu profesión.'
            );


            return;

        }


        const payload =
            construirPayloadResto({

                profesion:
                    profesionEditar,

                otroProfesion:
                    otroProfesionEditar
                        .trim(),

                nivel_estudios:
                    nivelEstudiosEditar,

                ocupacion:
                    ocupacionEditar,

                matricula:
                    matriculaEditar
                        .trim()

            });


        dispatch(
            ocultarAlertaAction()
        );


        dispatch(
            almacenarRestoAction({

                payload,

                config

            })
        );


        setEditarProfesionales(
            false
        );

    };


    /*
    ========================================
    UBICACIÓN
    ========================================
    */

    const abrirEditarUbicacion = () => {

        setUbicacionEditar(
            ubicacion ||
            {}
        );


        setErrorUbicacion(
            ''
        );


        setEditarUbicacion(
            true
        );

    };


    const cancelarEditarUbicacion = () => {

        setUbicacionEditar(
            ubicacion ||
            {}
        );


        setErrorUbicacion(
            ''
        );


        setEditarUbicacion(
            false
        );

    };


    const guardarUbicacion = (
        e
    ) => {

        e.preventDefault();


        if (
            !validarUbicacion(
                ubicacionEditar
            )
        ) {

            setErrorUbicacion(
                'Completá una ubicación válida.'
            );


            return;

        }


        const payload =
            construirPayloadResto({

                ubicacion:
                    ubicacionEditar

            });


        dispatch(
            ocultarAlertaAction()
        );


        dispatch(
            almacenarRestoAction({

                payload,

                config

            })
        );


        setEditarUbicacion(
            false
        );

    };


    /*
    ========================================
    CAMBIAR EMAIL
    ========================================
    */

    const guardarEmailProfesional =
        async (
            e
        ) => {

        e.preventDefault();


        const emailNuevo =
            emailProfesional
                .current
                ?.value
                ?.trim() ||
            '';


        const codigo =
            tokenRecupero
                .current
                ?.value
                ?.trim() ||
            '';


        if (
            !emailNuevo ||
            !codigo
        ) {

            setIncompletoEmailProfesional(
                true
            );


            dispatch(
                setearAlerta({
                    msg:
                        'Completá el email nuevo y el código de verificación'
                })
            );


            return;

        }


        setIncompletoEmailProfesional(
            false
        );


        dispatch(
            ocultarAlertaAction()
        );


        const respuesta =
            await dispatch(
                almacenarEmailAction({

                    payload: {

                        email:
                            emailNuevo
                                .toLowerCase(),

                        codigo

                    },

                    config

                })
            );


        if (
            !respuesta?.ok
        ) {

            return;

        }


        setOpenEmail(
            false
        );


        setCambiarEmail(
            false
        );

    };


    /*
    ========================================
    PASSWORD
    ========================================
    */

    const guardarPassword = (
        e
    ) => {

        e.preventDefault();


        const anterior =
            password
                .current
                ?.value ||
            '';


        const nueva =
            passwordNueva
                .current
                ?.value ||
            '';


        const repetir =
            verificarPasswordNueva
                .current
                ?.value ||
            '';


        if (
            !anterior ||
            !nueva ||
            !repetir
        ) {

            setIncompletoPassword(
                true
            );


            dispatch(
                setearAlerta({
                    msg:
                        'Todos los campos de contraseña son obligatorios'
                })
            );


            return;

        }


        if (
            nueva !==
            repetir
        ) {

            setIncompletoPassword(
                true
            );


            dispatch(
                setearAlerta({
                    msg:
                        'Las contraseñas deben coincidir'
                })
            );


            return;

        }


        if (
            nueva.length <
            8 ||
            nueva.length >
            15
        ) {

            setIncompletoPassword(
                true
            );


            dispatch(
                setearAlerta({
                    msg:
                        'La contraseña debe tener entre 8 y 15 caracteres'
                })
            );


            return;

        }


        if (
            !/[a-z]/.test(
                nueva
            )
        ) {

            setIncompletoPassword(
                true
            );


            dispatch(
                setearAlerta({
                    msg:
                        'La contraseña debe contener al menos una minúscula'
                })
            );


            return;

        }


        if (
            !/[A-Z]/.test(
                nueva
            )
        ) {

            setIncompletoPassword(
                true
            );


            dispatch(
                setearAlerta({
                    msg:
                        'La contraseña debe contener al menos una mayúscula'
                })
            );


            return;

        }


        if (
            !/[0-9]/.test(
                nueva
            )
        ) {

            setIncompletoPassword(
                true
            );


            dispatch(
                setearAlerta({
                    msg:
                        'La contraseña debe contener al menos un número'
                })
            );


            return;

        }


        setIncompletoPassword(
            false
        );


        dispatch(
            ocultarAlertaAction()
        );


        dispatch(
            almacenarContraseniaAction({

                payload: {

                    password:
                        anterior,

                    passwordNueva:
                        nueva

                },

                config

            })
        );


        setOpenContrasenia(
            false
        );

    };


    /*
    ========================================
    TOKEN CAMBIO EMAIL
    ========================================
    */

    const enviarCambiarEmail = (
        e
    ) => {

        e.preventDefault();


        setCambiarEmail(
            true
        );


        dispatch(
            solicitoTokenPerfilProfesionalAction({
                config
            })
        );

    };


    const habilitarIngresoCodigo = (
        e
    ) => {

        e.preventDefault();


        setCambiarEmail(
            true
        );

    };


    /*
    ========================================
    CONSULTORIOS
    ========================================
    */

    const limpiarFormularioConsultorio = () => {

        setConsultorioEditandoId(
            null
        );


        setConsultorioNombre(
            ''
        );


        setConsultorioDireccion(
            ''
        );


        setConsultorioTelefono(
            ''
        );


        setConsultorioDefault(
            false
        );

    };


    const abrirNuevoConsultorio = () => {

        limpiarFormularioConsultorio();


        setOpenConsultorios(
            true
        );

    };


    const editarConsultorio = (
        consultorio
    ) => {

        setConsultorioEditandoId(
            consultorio.id
        );


        setConsultorioNombre(
            consultorio.nombre ||
            ''
        );


        setConsultorioDireccion(
            consultorio.direccion ||
            ''
        );


        setConsultorioTelefono(
            consultorio.telefono ||
            ''
        );


        setConsultorioDefault(
            Boolean(
                consultorio.es_default
            )
        );


        setOpenConsultorios(
            true
        );

    };


    const guardarConsultorio = async (
        e
    ) => {

        e.preventDefault();


        if (
            !consultorioNombre
                .trim()
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'El nombre del consultorio es obligatorio'
                })
            );


            return;

        }


        const payload = {

            nombre:
                consultorioNombre
                    .trim(),

            direccion:
                consultorioDireccion
                    .trim(),

            telefono:
                consultorioTelefono
                    .trim(),

            es_default:
                Boolean(
                    consultorioDefault
                ),

            orden:
                0

        };


        let guardadoCorrectamente =
            false;


        if (
            consultorioEditandoId
        ) {

            guardadoCorrectamente =
                await dispatch(

                    editarConsultorioProfesionalAction({

                        config,

                        payload: {

                            id:
                                consultorioEditandoId,

                            ...payload

                        }

                    })

                );

        } else {

            guardadoCorrectamente =
                await dispatch(

                    crearConsultorioProfesionalAction({

                        config,

                        payload

                    })

                );

        }


        if (
            !guardadoCorrectamente
        ) {

            return;

        }


        limpiarFormularioConsultorio();


        setOpenConsultorios(
            false
        );

    };


    const cancelarEdicionConsultorio = () => {

        limpiarFormularioConsultorio();


        setOpenConsultorios(
            false
        );

    };


    const borrarConsultorio = async (
        consultorio
    ) => {

        const confirmar =
            window.confirm(
                `¿Querés eliminar el consultorio "${consultorio.nombre}"?`
            );


        if (
            !confirmar
        ) {

            return;

        }


        await dispatch(

            borrarConsultorioProfesionalAction({

                config,

                payload: {

                    id:
                        consultorio.id

                }

            })

        );

    };


    const marcarConsultorioDefault = async (
        consultorio
    ) => {

        await dispatch(

            editarConsultorioProfesionalAction({

                config,

                payload: {

                    id:
                        consultorio.id,

                    nombre:
                        consultorio.nombre ||
                        '',

                    direccion:
                        consultorio.direccion ||
                        '',

                    telefono:
                        consultorio.telefono ||
                        '',

                    es_default:
                        true,

                    orden:
                        consultorio.orden ||
                        0

                }

            })

        );

    };


    /*
    ========================================
    RESPUESTAS
    ========================================
    */

    useEffect(
        () => {

            if (
                !estado?.msg
            ) {

                return;

            }


            if (
                estado.msg ===
                'Actualizado'
            ) {

                return;

            }


            dispatch(
                setearAlerta({
                    msg:
                        estado.msg
                })
            );

        },
        [
            estado,
            dispatch
        ]
    );


    /*
    ========================================
    OCULTAR ALERTA
    ========================================
    */

    useEffect(
        () => {

            if (
                !alerta
            ) {

                return;

            }


            const timeoutId =
                setTimeout(
                    () => {

                        dispatch(
                            ocultarAlertaAction()
                        );

                    },
                    2500
                );


            return () =>
                clearTimeout(
                    timeoutId
                );

        },
        [
            alerta,
            dispatch
        ]
    );


    /*
    ========================================
    CONSULTORIOS
    ========================================
    */

    useEffect(
        () => {

            if (
                !config
            ) {

                return;

            }


            if (
                consultoriosSolicitadosRef
                    .current
            ) {

                return;

            }


            consultoriosSolicitadosRef
                .current =
                true;


            dispatch(
                cargarConsultoriosProfesionalAction({
                    config
                })
            );

        },
        [
            config,
            dispatch
        ]
    );


    /*
    ========================================
    ERROR GENERAL
    ========================================
    */

    const mensajeError =

        typeof error ===
        'string'

            ?
            error

            :
            error?.msg ||
            '';


    /*
    ========================================
    OPCIONES
    ========================================
    */

    const opcionesGenero =
        obtenerOpcionesSelect(
            generoData,
            generoEditar
        );


    const opcionesNivelEstudios =
        obtenerOpcionesSelect(
            nivelEstudiosData,
            nivelEstudiosEditar
        );


    const opcionesProfesion =
        obtenerOpcionesSelect(
            tipoProfesionalData,
            profesionEditar
        );


    const opcionesOcupacion =
        obtenerOpcionesSelect(
            ocupacionProfesionalData,
            ocupacionEditar
        );


    /*
    ========================================
    RENDER
    ========================================
    */

    return (

        <CuerpoCompleto>


            <HeaderUno />


            <HeaderDos

                link="/escritorio/calendario"

                componente="Perfil"

                paciente={false}

            />


            <PaginaPerfil>

                <EncabezadoPagina>

                    <DescripcionPagina>
                        Administrá tus datos personales,
                        información profesional,
                        ubicación, seguridad y sedes.
                    </DescripcionPagina>

                </EncabezadoPagina>

                {
                    cargando && (

                        <MensajeEstado>

                            Procesando información...

                        </MensajeEstado>

                    )
                }


                {
                    mensajeError && (

                        <MensajeEstado $error>

                            {
                                mensajeError
                            }

                        </MensajeEstado>

                    )
                }


                {
                    alerta?.msg && (

                        <MensajeEstado $error>

                            {
                                alerta.msg
                            }

                        </MensajeEstado>

                    )
                }


                <GridTarjetas>


                    {/* =====================================
                        IDENTIDAD
                    ====================================== */}

                    <Tarjeta>


                        <CabeceraTarjeta>

                            <BloqueTituloTarjeta>

                                <TituloTarjeta>
                                    Identidad
                                </TituloTarjeta>


                                <SubtituloTarjeta>

                                    Nombre y apellido
                                    asociados a tu cuenta.

                                </SubtituloTarjeta>

                            </BloqueTituloTarjeta>


                            {
                                !editarIdentidad && (

                                    <BotonEditarTarjeta

                                        type="button"

                                        onClick={
                                            abrirEditarIdentidad
                                        }

                                    >

                                        <IconoBoton

                                            src="/img/editar.svg"

                                            alt=""

                                        />

                                        Editar

                                    </BotonEditarTarjeta>

                                )
                            }

                        </CabeceraTarjeta>


                        {
                            !editarIdentidad
                                ?
                                (

                                    <DatosGrid>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Nombre
                                            </EtiquetaDato>

                                            <ValorDato>

                                                {
                                                    nombre ||
                                                    'Sin especificar'
                                                }

                                            </ValorDato>

                                        </DatoBloque>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Apellido
                                            </EtiquetaDato>

                                            <ValorDato>

                                                {
                                                    apellido ||
                                                    'Sin especificar'
                                                }

                                            </ValorDato>

                                        </DatoBloque>


                                    </DatosGrid>

                                )
                                :
                                (

                                    <PanelEdicion>


                                        <GridCampos>


                                            <Campo>

                                                <LabelCampo>
                                                    Nombre
                                                </LabelCampo>


                                                <InputCampo

                                                    type="text"

                                                    value={
                                                        nombreEditar
                                                    }

                                                    onChange={
                                                        e => {

                                                            setNombreEditar(
                                                                e.target.value
                                                            );

                                                            setErrorIdentidad(
                                                                ''
                                                            );

                                                        }
                                                    }

                                                />

                                            </Campo>


                                            <Campo>

                                                <LabelCampo>
                                                    Apellido
                                                </LabelCampo>


                                                <InputCampo

                                                    type="text"

                                                    value={
                                                        apellidoEditar
                                                    }

                                                    onChange={
                                                        e => {

                                                            setApellidoEditar(
                                                                e.target.value
                                                            );

                                                            setErrorIdentidad(
                                                                ''
                                                            );

                                                        }
                                                    }

                                                />

                                            </Campo>


                                        </GridCampos>


                                        {
                                            errorIdentidad && (

                                                <TextoError>

                                                    {
                                                        errorIdentidad
                                                    }

                                                </TextoError>

                                            )
                                        }


                                        <TextoAyuda>

                                            Si modificás nombre o apellido,
                                            no podrás volver a cambiarlos
                                            durante 90 días.

                                        </TextoAyuda>


                                        <FilaAcciones>

                                            <BotonSecundario

                                                type="button"

                                                onClick={
                                                    cancelarEditarIdentidad
                                                }

                                            >

                                                Cancelar

                                            </BotonSecundario>


                                            <BotonPrimario

                                                type="button"

                                                onClick={
                                                    guardarIdentidad
                                                }

                                            >

                                                Guardar cambios

                                            </BotonPrimario>

                                        </FilaAcciones>


                                    </PanelEdicion>

                                )
                        }


                    </Tarjeta>


                    {/* =====================================
                        DATOS PERSONALES
                    ====================================== */}

                    <Tarjeta>


                        <CabeceraTarjeta>

                            <BloqueTituloTarjeta>

                                <TituloTarjeta>
                                    Datos personales
                                </TituloTarjeta>


                                <SubtituloTarjeta>

                                    Información personal
                                    complementaria.

                                </SubtituloTarjeta>

                            </BloqueTituloTarjeta>


                            {
                                !editarPersonales && (

                                    <BotonEditarTarjeta

                                        type="button"

                                        onClick={
                                            abrirEditarPersonales
                                        }

                                    >

                                        <IconoBoton

                                            src="/img/editar.svg"

                                            alt=""

                                        />

                                        Editar

                                    </BotonEditarTarjeta>

                                )
                            }

                        </CabeceraTarjeta>


                        {
                            !editarPersonales
                                ?
                                (

                                    <DatosGrid>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Género
                                            </EtiquetaDato>

                                            <ValorDato>

                                                {
                                                    generoMostrar
                                                }

                                            </ValorDato>

                                        </DatoBloque>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Fecha de nacimiento
                                            </EtiquetaDato>

                                            <ValorDato>

                                                {
                                                    formatearFechaParaMostrar(
                                                        fecha_nacimiento
                                                    )
                                                }

                                            </ValorDato>

                                        </DatoBloque>


                                    </DatosGrid>

                                )
                                :
                                (

                                    <PanelEdicion>


                                        <GridCampos>


                                            <Campo>

                                                <LabelCampo>
                                                    Género
                                                </LabelCampo>


                                                <InputCampo

                                                    as="select"

                                                    value={
                                                        generoEditar
                                                    }

                                                    onChange={
                                                        e => {

                                                            setGeneroEditar(
                                                                e.target.value
                                                            );

                                                            setErrorPersonales(
                                                                ''
                                                            );

                                                        }
                                                    }

                                                >

                                                    <option value="">
                                                        Seleccionar
                                                    </option>


                                                    {
                                                        opcionesGenero.map(
                                                            opcion => (

                                                                <option

                                                                    key={
                                                                        opcion.id
                                                                    }

                                                                    value={
                                                                        opcion.id
                                                                    }

                                                                >

                                                                    {
                                                                        opcion.parametro
                                                                    }

                                                                </option>

                                                            )
                                                        )
                                                    }

                                                </InputCampo>

                                            </Campo>


                                            <Campo>

                                                <LabelCampo>
                                                    Fecha de nacimiento
                                                </LabelCampo>


                                                <InputCampo

                                                    type="date"

                                                    value={
                                                        fechaNacimientoEditar
                                                    }

                                                    onChange={
                                                        e => {

                                                            setFechaNacimientoEditar(
                                                                e.target.value
                                                            );

                                                            setErrorPersonales(
                                                                ''
                                                            );

                                                        }
                                                    }

                                                />

                                            </Campo>


                                        </GridCampos>


                                        {
                                            errorPersonales && (

                                                <TextoError>

                                                    {
                                                        errorPersonales
                                                    }

                                                </TextoError>

                                            )
                                        }


                                        <FilaAcciones>

                                            <BotonSecundario

                                                type="button"

                                                onClick={
                                                    cancelarEditarPersonales
                                                }

                                            >

                                                Cancelar

                                            </BotonSecundario>


                                            <BotonPrimario

                                                type="button"

                                                onClick={
                                                    guardarDatosPersonales
                                                }

                                            >

                                                Guardar cambios

                                            </BotonPrimario>

                                        </FilaAcciones>


                                    </PanelEdicion>

                                )
                        }


                    </Tarjeta>


                    {/* =====================================
                        DATOS PROFESIONALES
                    ====================================== */}

                    <Tarjeta>


                        <CabeceraTarjeta>

                            <BloqueTituloTarjeta>

                                <TituloTarjeta>
                                    Datos profesionales
                                </TituloTarjeta>


                                <SubtituloTarjeta>

                                    Información sobre
                                    tu actividad profesional.

                                </SubtituloTarjeta>

                            </BloqueTituloTarjeta>


                            {
                                !editarProfesionales && (

                                    <BotonEditarTarjeta

                                        type="button"

                                        onClick={
                                            abrirEditarProfesionales
                                        }

                                    >

                                        <IconoBoton

                                            src="/img/editar.svg"

                                            alt=""

                                        />

                                        Editar

                                    </BotonEditarTarjeta>

                                )
                            }

                        </CabeceraTarjeta>


                        {
                            !editarProfesionales
                                ?
                                (

                                    <DatosGrid>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Profesión
                                            </EtiquetaDato>

                                            <ValorDato>

                                                {
                                                    profesionMostrar
                                                }

                                            </ValorDato>

                                        </DatoBloque>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Nivel de estudios
                                            </EtiquetaDato>

                                            <ValorDato>

                                                {
                                                    estudiosMostrar
                                                }

                                            </ValorDato>

                                        </DatoBloque>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Ocupación
                                            </EtiquetaDato>

                                            <ValorDato>

                                                {
                                                    ocupacionMostrar
                                                }

                                            </ValorDato>

                                        </DatoBloque>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Matrícula
                                            </EtiquetaDato>

                                            <ValorDato>

                                                {
                                                    matricula ||
                                                    'Sin especificar'
                                                }

                                            </ValorDato>

                                        </DatoBloque>


                                        {
                                            String(
                                                profesion
                                            ) ===
                                            '99' && (

                                                <DatoBloque $completo>

                                                    <EtiquetaDato>
                                                        Otra profesión
                                                    </EtiquetaDato>

                                                    <ValorDato>

                                                        {
                                                            otroProfesion ||
                                                            'Sin especificar'
                                                        }

                                                    </ValorDato>

                                                </DatoBloque>

                                            )
                                        }


                                    </DatosGrid>

                                )
                                :
                                (

                                    <PanelEdicion>


                                        <GridCampos>


                                            <Campo>

                                                <LabelCampo>
                                                    Profesión
                                                </LabelCampo>


                                                <InputCampo

                                                    as="select"

                                                    value={
                                                        profesionEditar
                                                    }

                                                    onChange={
                                                        e => {

                                                            setProfesionEditar(
                                                                e.target.value
                                                            );

                                                            setErrorProfesionales(
                                                                ''
                                                            );

                                                        }
                                                    }

                                                >

                                                    <option value="">
                                                        Seleccionar
                                                    </option>


                                                    {
                                                        opcionesProfesion.map(
                                                            opcion => (

                                                                <option

                                                                    key={
                                                                        opcion.id
                                                                    }

                                                                    value={
                                                                        opcion.id
                                                                    }

                                                                >

                                                                    {
                                                                        opcion.parametro
                                                                    }

                                                                </option>

                                                            )
                                                        )
                                                    }

                                                </InputCampo>

                                            </Campo>


                                            <Campo>

                                                <LabelCampo>
                                                    Nivel de estudios
                                                </LabelCampo>


                                                <InputCampo

                                                    as="select"

                                                    value={
                                                        nivelEstudiosEditar
                                                    }

                                                    onChange={
                                                        e =>

                                                            setNivelEstudiosEditar(
                                                                e.target.value
                                                            )
                                                    }

                                                >

                                                    <option value="">
                                                        Seleccionar
                                                    </option>


                                                    {
                                                        opcionesNivelEstudios.map(
                                                            opcion => (

                                                                <option

                                                                    key={
                                                                        opcion.id
                                                                    }

                                                                    value={
                                                                        opcion.id
                                                                    }

                                                                >

                                                                    {
                                                                        opcion.parametro
                                                                    }

                                                                </option>

                                                            )
                                                        )
                                                    }

                                                </InputCampo>

                                            </Campo>


                                            <Campo>

                                                <LabelCampo>
                                                    Ocupación
                                                </LabelCampo>


                                                <InputCampo

                                                    as="select"

                                                    value={
                                                        ocupacionEditar
                                                    }

                                                    onChange={
                                                        e =>

                                                            setOcupacionEditar(
                                                                e.target.value
                                                            )
                                                    }

                                                >

                                                    <option value="">
                                                        Seleccionar
                                                    </option>


                                                    {
                                                        opcionesOcupacion.map(
                                                            opcion => (

                                                                <option

                                                                    key={
                                                                        opcion.id
                                                                    }

                                                                    value={
                                                                        opcion.id
                                                                    }

                                                                >

                                                                    {
                                                                        opcion.parametro
                                                                    }

                                                                </option>

                                                            )
                                                        )
                                                    }

                                                </InputCampo>

                                            </Campo>


                                            <Campo>

                                                <LabelCampo>
                                                    Matrícula
                                                </LabelCampo>


                                                <InputCampo

                                                    type="text"

                                                    value={
                                                        matriculaEditar
                                                    }

                                                    onChange={
                                                        e =>

                                                            setMatriculaEditar(
                                                                e.target.value
                                                            )
                                                    }

                                                />

                                            </Campo>


                                            {
                                                String(
                                                    profesionEditar
                                                ) ===
                                                '99' && (

                                                    <Campo>

                                                        <LabelCampo>
                                                            Otra profesión
                                                        </LabelCampo>


                                                        <InputCampo

                                                            type="text"

                                                            value={
                                                                otroProfesionEditar
                                                            }

                                                            onChange={
                                                                e => {

                                                                    setOtroProfesionEditar(
                                                                        e.target.value
                                                                    );

                                                                    setErrorProfesionales(
                                                                        ''
                                                                    );

                                                                }
                                                            }

                                                        />

                                                    </Campo>

                                                )
                                            }


                                        </GridCampos>


                                        {
                                            errorProfesionales && (

                                                <TextoError>

                                                    {
                                                        errorProfesionales
                                                    }

                                                </TextoError>

                                            )
                                        }


                                        <FilaAcciones>

                                            <BotonSecundario

                                                type="button"

                                                onClick={
                                                    cancelarEditarProfesionales
                                                }

                                            >

                                                Cancelar

                                            </BotonSecundario>


                                            <BotonPrimario

                                                type="button"

                                                onClick={
                                                    guardarDatosProfesionales
                                                }

                                            >

                                                Guardar cambios

                                            </BotonPrimario>

                                        </FilaAcciones>


                                    </PanelEdicion>

                                )
                        }


                    </Tarjeta>


                    {/* =====================================
                        UBICACIÓN
                    ====================================== */}

                    <Tarjeta>


                        <CabeceraTarjeta>

                            <BloqueTituloTarjeta>

                                <TituloTarjeta>
                                    Ubicación
                                </TituloTarjeta>


                                <SubtituloTarjeta>

                                    Región asociada a tu
                                    perfil profesional.

                                </SubtituloTarjeta>

                            </BloqueTituloTarjeta>


                            {
                                !editarUbicacion && (

                                    <BotonEditarTarjeta

                                        type="button"

                                        onClick={
                                            abrirEditarUbicacion
                                        }

                                    >

                                        <IconoBoton

                                            src="/img/editar.svg"

                                            alt=""

                                        />

                                        Editar

                                    </BotonEditarTarjeta>

                                )
                            }

                        </CabeceraTarjeta>


                        {
                            !editarUbicacion
                                ?
                                (

                                    <Fragment>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Ubicación actual
                                            </EtiquetaDato>

                                            <ValorDato $destacado>

                                                {
                                                    ubicacionMostrada ||
                                                    'Sin ubicación cargada'
                                                }

                                            </ValorDato>

                                        </DatoBloque>


                                        {
                                            !ubicacion &&
                                            ubicacionMostrada && (

                                                <TextoAyuda>

                                                    Esta ubicación pertenece
                                                    al sistema anterior.
                                                    Podés conservarla o
                                                    actualizarla cuando quieras.

                                                </TextoAyuda>

                                            )
                                        }


                                    </Fragment>

                                )
                                :
                                (

                                    <PanelEdicion>


                                        {
                                            !ubicacion &&
                                            ubicacionMostrada && (

                                                <AvisoLegacy>

                                                    Actualmente tu perfil
                                                    conserva la ubicación
                                                    anterior.

                                                    Si querés migrarla,
                                                    seleccioná nuevamente
                                                    tu ubicación.

                                                </AvisoLegacy>

                                            )
                                        }


                                        <BloqueUbicacion>

                                            <SelectorUbicacion

                                                value={
                                                    ubicacionEditar
                                                }

                                                onChange={
                                                    nuevaUbicacion => {

                                                        setUbicacionEditar(
                                                            nuevaUbicacion
                                                        );

                                                        setErrorUbicacion(
                                                            ''
                                                        );

                                                    }
                                                }

                                                prefijo="perfil-profesional"

                                                titulo="Ubicación profesional"

                                            />


                                            {
                                                errorUbicacion && (

                                                    <TextoError>

                                                        {
                                                            errorUbicacion
                                                        }

                                                    </TextoError>

                                                )
                                            }

                                        </BloqueUbicacion>


                                        <FilaAcciones>

                                            <BotonSecundario

                                                type="button"

                                                onClick={
                                                    cancelarEditarUbicacion
                                                }

                                            >

                                                Cancelar

                                            </BotonSecundario>


                                            <BotonPrimario

                                                type="button"

                                                onClick={
                                                    guardarUbicacion
                                                }

                                            >

                                                Guardar ubicación

                                            </BotonPrimario>

                                        </FilaAcciones>


                                    </PanelEdicion>

                                )
                        }


                    </Tarjeta>


                    {/* =====================================
                        SEGURIDAD
                    ====================================== */}

                    <TarjetaAncha>


                        <CabeceraTarjeta>

                            <BloqueTituloTarjeta>

                                <TituloTarjeta>
                                    Seguridad
                                </TituloTarjeta>


                                <SubtituloTarjeta>

                                    Administrá tu email
                                    y contraseña.

                                </SubtituloTarjeta>

                            </BloqueTituloTarjeta>

                        </CabeceraTarjeta>


                        {
                            !openEmail &&
                            !openContrasenia && (

                                <Fragment>


                                    <DatosGrid>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Email
                                            </EtiquetaDato>

                                            <ValorDato>

                                                {
                                                    email ||
                                                    'Sin especificar'
                                                }

                                            </ValorDato>

                                        </DatoBloque>


                                        <DatoBloque>

                                            <EtiquetaDato>
                                                Contraseña
                                            </EtiquetaDato>

                                            <ValorDato>
                                                ••••••••••
                                            </ValorDato>

                                        </DatoBloque>


                                    </DatosGrid>


                                    <SeguridadAcciones>


                                        <BotonSeguridad

                                            type="button"

                                            onClick={() => {

                                                setOpenEmail(
                                                    true
                                                );

                                                setOpenContrasenia(
                                                    false
                                                );

                                            }}

                                        >

                                            Cambiar email

                                        </BotonSeguridad>


                                        <BotonSeguridad

                                            type="button"

                                            onClick={() => {

                                                setOpenContrasenia(
                                                    true
                                                );

                                                setOpenEmail(
                                                    false
                                                );

                                            }}

                                        >

                                            Cambiar contraseña

                                        </BotonSeguridad>


                                    </SeguridadAcciones>


                                </Fragment>

                            )
                        }


                        {/* =====================================
                            CAMBIO EMAIL
                        ====================================== */}

                        {
                            openEmail && (

                                <PanelEdicion>


                                    {
                                        !cambiarEmail
                                            ?
                                            (

                                                <Fragment>


                                                    <TextoAyuda>

                                                        Para cambiar tu email
                                                        necesitamos verificar
                                                        tu identidad.

                                                        Te enviaremos un código
                                                        de seguridad a:

                                                        <strong>
                                                            {' '}
                                                            {
                                                                email
                                                            }
                                                        </strong>

                                                    </TextoAyuda>


                                                    <FilaAcciones $izquierda>

                                                        <BotonSecundario

                                                            type="button"

                                                            onClick={() => {

                                                                setOpenEmail(
                                                                    false
                                                                );

                                                                setCambiarEmail(
                                                                    false
                                                                );

                                                            }}

                                                        >

                                                            Cancelar

                                                        </BotonSecundario>


                                                        <BotonSecundario

                                                            type="button"

                                                            onClick={
                                                                habilitarIngresoCodigo
                                                            }

                                                        >

                                                            Ya tengo un código

                                                        </BotonSecundario>


                                                        <BotonPrimario

                                                            type="button"

                                                            onClick={
                                                                enviarCambiarEmail
                                                            }

                                                        >

                                                            Enviar código

                                                        </BotonPrimario>

                                                    </FilaAcciones>


                                                </Fragment>

                                            )
                                            :
                                            (

                                                <Fragment>


                                                    <GridCampos>


                                                        <Campo>

                                                            <LabelCampo>
                                                                Email nuevo
                                                            </LabelCampo>


                                                            <InputCampo

                                                                type="email"

                                                                ref={
                                                                    emailProfesional
                                                                }

                                                                defaultValue={
                                                                    email
                                                                }

                                                            />

                                                        </Campo>


                                                        <Campo>

                                                            <LabelCampo>
                                                                Código de verificación
                                                            </LabelCampo>


                                                            <InputCampo

                                                                type="text"

                                                                ref={
                                                                    tokenRecupero
                                                                }

                                                                placeholder="Código recibido"

                                                            />

                                                        </Campo>


                                                    </GridCampos>


                                                    {
                                                        incompletoEmailProfesional && (

                                                            <TextoError>

                                                                Completá ambos campos.

                                                            </TextoError>

                                                        )
                                                    }


                                                    <TextoAyuda>

                                                        Si todavía no llegó,
                                                        esperá unos minutos
                                                        y revisá también la
                                                        carpeta de correo no
                                                        deseado.

                                                    </TextoAyuda>


                                                    <FilaAcciones>

                                                        <BotonSecundario

                                                            type="button"

                                                            onClick={() => {

                                                                setOpenEmail(
                                                                    false
                                                                );

                                                                setCambiarEmail(
                                                                    false
                                                                );

                                                                setIncompletoEmailProfesional(
                                                                    false
                                                                );

                                                            }}

                                                        >

                                                            Cancelar

                                                        </BotonSecundario>


                                                        <BotonPrimario

                                                            type="button"

                                                            onClick={
                                                                guardarEmailProfesional
                                                            }

                                                        >

                                                            Guardar email

                                                        </BotonPrimario>

                                                    </FilaAcciones>


                                                </Fragment>

                                            )
                                    }


                                </PanelEdicion>

                            )
                        }


                        {/* =====================================
                            CAMBIO CONTRASEÑA
                        ====================================== */}

                        {
                            openContrasenia && (

                                <PanelEdicion>


                                    <GridCampos $unaColumna>


                                        <Campo>

                                            <LabelCampo>
                                                Contraseña actual
                                            </LabelCampo>


                                            <InputCampo

                                                type="password"

                                                ref={
                                                    password
                                                }

                                                autoComplete="current-password"

                                            />

                                        </Campo>


                                        <Campo>

                                            <LabelCampo>
                                                Contraseña nueva
                                            </LabelCampo>


                                            <InputCampo

                                                type="password"

                                                ref={
                                                    passwordNueva
                                                }

                                                autoComplete="new-password"

                                            />

                                        </Campo>


                                        <Campo>

                                            <LabelCampo>
                                                Repetir contraseña nueva
                                            </LabelCampo>


                                            <InputCampo

                                                type="password"

                                                ref={
                                                    verificarPasswordNueva
                                                }

                                                autoComplete="new-password"

                                            />

                                        </Campo>


                                    </GridCampos>


                                    {
                                        incompletoPassword && (

                                            <TextoError>

                                                Revisá los datos ingresados.

                                            </TextoError>

                                        )
                                    }


                                    <TextoAyuda>

                                        La contraseña debe tener entre
                                        8 y 15 caracteres, una mayúscula,
                                        una minúscula y al menos un número.

                                    </TextoAyuda>


                                    <FilaAcciones>

                                        <BotonSecundario

                                            type="button"

                                            onClick={() => {

                                                setOpenContrasenia(
                                                    false
                                                );

                                                setIncompletoPassword(
                                                    false
                                                );

                                            }}

                                        >

                                            Cancelar

                                        </BotonSecundario>


                                        <BotonPrimario

                                            type="button"

                                            onClick={
                                                guardarPassword
                                            }

                                        >

                                            Cambiar contraseña

                                        </BotonPrimario>

                                    </FilaAcciones>


                                </PanelEdicion>

                            )
                        }


                    </TarjetaAncha>


                    {/* =====================================
                        CONSULTORIOS / SEDES
                    ====================================== */}

                    <TarjetaAncha>


                        <CabeceraTarjeta>

                            <BloqueTituloTarjeta>

                                <TituloTarjeta>
                                    Consultorios / sedes
                                </TituloTarjeta>


                                <SubtituloTarjeta>

                                    Administrá los lugares
                                    donde atendés de forma
                                    presencial.

                                </SubtituloTarjeta>

                            </BloqueTituloTarjeta>


                            {
                                !openConsultorios && (

                                    <BotonPrimario

                                        type="button"

                                        onClick={
                                            abrirNuevoConsultorio
                                        }

                                    >

                                        + Agregar consultorio

                                    </BotonPrimario>

                                )
                            }

                        </CabeceraTarjeta>


                        {
                            consultoriosCargando && (

                                <MensajeEstado>

                                    Cargando consultorios...

                                </MensajeEstado>

                            )
                        }


                        {
                            !consultoriosCargando &&
                            consultoriosProfesional.length ===
                            0 &&
                            !openConsultorios && (

                                <EstadoVacio>

                                    Todavía no cargaste
                                    consultorios o sedes.

                                    <br />

                                    Podés agregar uno para
                                    utilizarlo al crear
                                    turnos presenciales.

                                </EstadoVacio>

                            )
                        }


                        {
                            consultoriosProfesional.length >
                            0 && (

                                <ListaConsultorios>


                                    {
                                        consultoriosProfesional.map(
                                            consultorio => (

                                                <TarjetaConsultorio
                                                    key={
                                                        consultorio.id
                                                    }
                                                >


                                                    <CabeceraConsultorio>


                                                        <NombreConsultorio>

                                                            {
                                                                consultorio.nombre
                                                            }

                                                        </NombreConsultorio>


                                                        {
                                                            consultorio.es_default && (

                                                                <BadgeDefault>
                                                                    Default
                                                                </BadgeDefault>

                                                            )
                                                        }


                                                    </CabeceraConsultorio>


                                                    <DatosConsultorio>


                                                        <DatoBloque>

                                                            <EtiquetaDato>
                                                                Dirección
                                                            </EtiquetaDato>

                                                            <ValorDato>

                                                                {
                                                                    consultorio.direccion ||
                                                                    'Sin dirección cargada'
                                                                }

                                                            </ValorDato>

                                                        </DatoBloque>


                                                        <DatoBloque>

                                                            <EtiquetaDato>
                                                                Teléfono / WhatsApp
                                                            </EtiquetaDato>

                                                            <ValorDato>

                                                                {
                                                                    consultorio.telefono ||
                                                                    'Sin teléfono cargado'
                                                                }

                                                            </ValorDato>

                                                        </DatoBloque>


                                                    </DatosConsultorio>


                                                    <AccionesConsultorio>


                                                        {
                                                            !consultorio.es_default && (

                                                                <BotonSecundario

                                                                    type="button"

                                                                    onClick={() =>
                                                                        marcarConsultorioDefault(
                                                                            consultorio
                                                                        )
                                                                    }

                                                                >

                                                                    Marcar default

                                                                </BotonSecundario>

                                                            )
                                                        }


                                                        <BotonSecundario

                                                            type="button"

                                                            onClick={() =>
                                                                editarConsultorio(
                                                                    consultorio
                                                                )
                                                            }

                                                        >

                                                            Editar

                                                        </BotonSecundario>


                                                        <BotonPeligro

                                                            type="button"

                                                            onClick={() =>
                                                                borrarConsultorio(
                                                                    consultorio
                                                                )
                                                            }

                                                        >

                                                            Eliminar

                                                        </BotonPeligro>


                                                    </AccionesConsultorio>


                                                </TarjetaConsultorio>

                                            )
                                        )
                                    }


                                </ListaConsultorios>

                            )
                        }


                        {
                            openConsultorios && (

                                <PanelEdicion>


                                    <GridCampos>


                                        <Campo>

                                            <LabelCampo>
                                                Nombre del consultorio *
                                            </LabelCampo>


                                            <InputCampo

                                                type="text"

                                                value={
                                                    consultorioNombre
                                                }

                                                placeholder="Ej: Consultorio Palermo"

                                                onChange={
                                                    e =>
                                                        setConsultorioNombre(
                                                            e.target.value
                                                        )
                                                }

                                            />

                                        </Campo>


                                        <Campo>

                                            <LabelCampo>
                                                Dirección
                                            </LabelCampo>


                                            <InputCampo

                                                type="text"

                                                value={
                                                    consultorioDireccion
                                                }

                                                placeholder="Ej: Av. Santa Fe 1234"

                                                onChange={
                                                    e =>
                                                        setConsultorioDireccion(
                                                            e.target.value
                                                        )
                                                }

                                            />

                                        </Campo>


                                        <Campo>

                                            <LabelCampo>
                                                Teléfono / WhatsApp
                                            </LabelCampo>


                                            <InputCampo

                                                type="text"

                                                value={
                                                    consultorioTelefono
                                                }

                                                placeholder="Ej: 1122334455"

                                                onChange={
                                                    e =>
                                                        setConsultorioTelefono(
                                                            e.target.value
                                                        )
                                                }

                                            />

                                        </Campo>


                                    </GridCampos>


                                    <FilaCheckbox>

                                        <Checkbox

                                            type="checkbox"

                                            checked={
                                                consultorioDefault
                                            }

                                            onChange={
                                                e =>
                                                    setConsultorioDefault(
                                                        e.target.checked
                                                    )
                                            }

                                        />


                                        Usar como consultorio default

                                    </FilaCheckbox>


                                    <FilaAcciones>

                                        <BotonSecundario

                                            type="button"

                                            onClick={
                                                cancelarEdicionConsultorio
                                            }

                                        >

                                            Cancelar

                                        </BotonSecundario>


                                        <BotonPrimario

                                            type="button"

                                            onClick={
                                                guardarConsultorio
                                            }

                                        >

                                            {
                                                consultorioEditandoId
                                                    ?
                                                    'Guardar consultorio'
                                                    :
                                                    'Crear consultorio'
                                            }

                                        </BotonPrimario>

                                    </FilaAcciones>


                                </PanelEdicion>

                            )
                        }


                    </TarjetaAncha>

                    {/* =====================================
                        LOGO PARA DOCUMENTOS
                    ====================================== */}

                    <LogoDocumentos config={config} />


                </GridTarjetas>


            </PaginaPerfil>


        </CuerpoCompleto>

    );

};


export default AdministrarPerfil;